import { PageRef } from 'providers/page-ref';

export type EquipmentEditPageParams = {
  equipment?: string;
  templateId?: string;
  suggestedTemplateId?: string;
  mode: 'create' | 'edit';
  returnCallback?: string;
  local?: {
    returnContext?: unknown;
  };
};

export const IEquipmentEditPage: PageRef<EquipmentEditPageParams, void> = {
  pageName: 'EquipmentEditPage',
} as PageRef<EquipmentEditPageParams, void>;
